import React, {Component} from 'react';
import Page from'components/Page';
import { rootPath, workoutSetupBase, emailPaywallMatches, homePath } from 'config/paths';
import * as transitions from 'assets/transitions';
import FlowForm, { FlowPageContent, FlowQuestionContainer, FlowQuestion, AutoAdvanceButton, NextButton, SmallImageCardOption, autoAdvanceSetValue } from 'components/FlowForm';
import { RespPsuedoImageCard, CardTitle, StaticAspectImageCard, CardContent, CardAction, CardReveal, CardImageWithPlaceholder } from 'components/Card';
import { formikHandlerCreator } from 'lib/utilities';
import Button from 'components/Button';
import { RCButtonWithErrors, Checkbox, CheckboxGroup, SingleOptionSlider, WeekdayButtonSelect, SmallButtonSelect, ToggleButton } from 'components/Form';
import { workoutFlowSelector, bannableProgSelector, userRecordSelector, possibleRoutinesSelector, unpossibleRoutinesSelector, unpossibleRoutinesParams } from 'redux/selectors';
import { advanceWorkoutSetup, loadBannableProgs, loadUserWorkoutTimes, loadPossibleRoutines, loadUnpossibleRoutines, assignNewRoutine } from 'redux/actions';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Redirect } from "components/Routing";
import loadingContainer, { LoadingContainerParent } from 'components/LoadingHOC';
import moment from 'moment';
import * as _ from 'lib/utilities';
import aestheticsF from 'assets/img/AestheticsF.png';
import strengthF from 'assets/img/StrengthF.png';
import aestheticsM from 'assets/img/AestheticsM.png';
import strengthM from 'assets/img/StrengthM.png';
import classnames from 'classnames';
import { SelectInput } from 'components/TextInput';
import ResponsiveSections from 'components/ResponsiveSections';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { dateFormat } from 'config/settings';
import { WorkoutRoutine, User } from 'lib/classes';
import { Link } from 'components/Routing';
import { workoutPlanSlideOutPaths } from 'partials/MainLayout';

const validateForm = (t,page,values) => {
    if(page === 1) {
        if(_.isBlank(values.gymType)) {
            return { gymType: t('Required') }
        }
    } else if (page === 2) {
        if(_.isBlank(values.needsCardio)) {
            return { needsCardio: t('Required') }
        }
    } else if (page === 3) {
        if(_.isBlank(values.routineFocus) && values.gymType === 2) {
            return { routineFocus: t('Required') }
        }
    } else if (page === 4) {
        if(_.isBlank(values.liftingExperience)) {
            return { liftingExperience: t('Required') }
        }
    } else if(page === 5) {
        const tDays = values.trainingDays || [];
        let err = false;
        if(tDays.length < 2) {
            err = true;
        } else if(tDays.length === 2) {
            if(Math.abs(tDays[0] - tDays[1]) <= 1 || Math.abs(tDays[0] - tDays[1]) === 6) {
                err = true;
            }
        }
        
        if(err) {
            return { trainingDays: t("Pick at least 2 non-consecutive days") }
        }
    } else if (page === 6) {
        if(_.isBlank(values.workoutTime)) {
            return { workoutTime: t('Required') }
        }
    } else if (page === 8) {
        if(_.isBlank(values.routineStart)) {
            return { routineStart: t('Required') }
        }
    }
    return {}
}

const getNextPage = (page,values) => {
    let newPage = page+1;
    if(newPage === 3 && values.gymType !== 2) {
        newPage += 1;
    }
    return newPage;
}

const valueFilter = values => _.pick(values,'newRoutine','routineStart','workoutRemind','workoutRemindPm')

const SubmissionLC = loadingContainer({
    'DEFAULT': ({ t }) => (<Button color="primary" rounded tag="button" type="submit" id="workout-setup-submit-btn">
            <FontAwesomeIcon icon='arrow-right' /><span>{t('Start Routine')}</span>
        </Button>),
    'SUCCESS': ({ user }) => (<Redirect to={user.afterWorkoutPlanSetupPath()} push />)
})

class StartDateQuestion extends React.Component {

    render() {
        const { flowProps, t, submitState, user } = this.props;
        const { setFieldValue, handleChange, handleBlur, values: { routineStart, workoutRemind, workoutRemindPm }} = flowProps;

        return (
            <React.Fragment>
                <FlowQuestion text={t("When do you want to start your routine?")} />
                <SelectInput 
                    name="routineStart" 
                    collection={_.nextWeekCollection(dateFormat)} 
                    browserDefault 
                    className="select-signup" 
                    value={routineStart} 
                    onChange={handleChange} 
                    onBlur={handleBlur} 
                />
                <FlowQuestion text={`${t("Workout reminder")}?`} />
                <div className="valign-wrapper cntr">
                    <SelectInput 
                        name="workoutRemind" 
                        collection={User.workoutRemindCol(t,true)} 
                        browserDefault 
                        className="select-signup mr5 ml0" 
                        value={workoutRemind} 
                        onChange={handleChange} 
                        onBlur={handleBlur} 
                    />
                    <ToggleButton
                        className="btn-no-shadow"
                        options={{
                            [`${t('AM')}`]: false, 
                            [`${t('PM')}`]: true}} 
                            value={workoutRemindPm} 
                            setValue={pref => setFieldValue('workoutRemindPm',pref)
                        } 
                    />
                </div>
                <div className="mt35">
                    <SubmissionLC t={t} loadState={submitState} user={user} />
                </div>
            </React.Fragment>
        )
    }
}

const RoutineCardActions = ({ flowProps, routine, t }) => {

    return (
        <React.Fragment>
            <AutoAdvanceButton {...flowProps} attr="newRoutine" value={routine.id} render={({ onClick }) => (
                <Button className="workout-routine-card" noShadow color="primary" rounded onClick={onClick}><span>{t('Select')}</span></Button>
            )} />
            <Button noShadow outlined color="primary" rounded className="activator ml5">{t('Info')}</Button>
        </React.Fragment>
    )
}

export const WorkoutRoutineCard = ({ routine, t, actions }) => {

    return (
        <StaticAspectImageCard action >
            <CardImageWithPlaceholder src={_.publicUrl() + `img/${routine.imageName}`} className="waves-effect waves-block waves-light activator" width={500} height={333} setDims>
                <div className="text-overlay-signup">
                    {routine.frequencyStr}x
                    <div className="subtitle">{t('week')}</div>
                </div>
                <div className="text-overlay-signup right">
                    {routine.estTimeStr}
                    <div className="subtitle">{t('mins')}</div>
                </div>
                <span className="routine-gray-overlay"></span>
            </CardImageWithPlaceholder>
            <CardContent className="routine-cards-padding buttonize activator">
                <CardTitle title={routine.name} className="grey-text text-darken-4 activator" />
            </CardContent>
            <CardAction className="pt10 pb10 center">
                {actions}
            </CardAction>
            <CardReveal>
                <CardTitle className="float-right icon-low-opacity pl15 pr10 pt5" icon="times"/>
                <p className="routine-text">
                    {routine.description}
                </p>
                {!_.isBlank(routine.sourceUrl) && (<p className="routine-text">
                    <Link to={routine.sourceUrl} target="_new">{t('Source')}</Link>
                </p>)}
            </CardReveal>
        </StaticAspectImageCard>
    )
}

const DefaultUnpossible = ({ load, t }) => (
    <RespPsuedoImageCard clickable double onClick={load} id="show-more-routines-btn">
        <CardTitle icon='eye' title={t('View all routines')}  className="card-title-gray" />
        <div className="pl5 pr5 lh1">{t("Additional routines don't match all your criteria")}</div>
    </RespPsuedoImageCard>
)

const UnpossibleLC = loadingContainer({
    'SUCCESS': () => '',
    'DEFAULT': DefaultUnpossible
})

const PossibleRoutines = ({ flowProps, t, workoutRoutines, unpossibleRoutines, unpossibleParams, loadUnpossible }) => {
    return (
        <ResponsiveSections centerLastRow>
            <AutoAdvanceButton {...flowProps} attr="newRoutine" value={''} render={({ onClick }) => (
                <RespPsuedoImageCard clickable onClick={onClick} id="pick-one-for-me-btn">
                    <CardTitle icon='arrow-right' title={t('Just pick the best one for me')} className="card-title-gray" />
                </RespPsuedoImageCard>
            )} />
            {workoutRoutines.map((routine) => (<WorkoutRoutineCard key={routine.id} routine={routine} flowProps={flowProps} t={t} actions={<RoutineCardActions flowProps={flowProps} routine={routine} t={t} />} />))}
            {unpossibleRoutines && unpossibleRoutines.map((routine) => (<WorkoutRoutineCard key={routine.id} routine={routine} flowProps={flowProps} t={t} actions={<RoutineCardActions flowProps={flowProps} routine={routine} t={t} />} />))}
            {!unpossibleRoutines && (<LoadingContainerParent 
                skipAutoLoad
                load={loadUnpossible.bind(null,unpossibleParams)}
                preloaded={() => !!unpossibleRoutines}
                component={UnpossibleLC}
                flowProps={flowProps}
                workoutRoutines={unpossibleRoutines}
                t={t}
            />)}
        </ResponsiveSections>
    )
}

const RoutinesLC = loadingContainer({
    'SUCCESS': PossibleRoutines
})

const PossibleRoutinesContainer = ({ flowProps, t, loadRoutines, loadUnpossible, unpossibleParams, workoutRoutines, unpossibleRoutines }) => {
    return (
        <LoadingContainerParent 
            load={loadRoutines.bind(null,flowProps.values)}
            preloaded={() => false}
            component={RoutinesLC}
            flowProps={flowProps}
            workoutRoutines={workoutRoutines}
            unpossibleRoutines={unpossibleRoutines}
            loadUnpossible={loadUnpossible}
            unpossibleParams={unpossibleParams}
            t={t}
        />
    )
}

const mapStateToWrt = state => ({
    workoutRoutines: possibleRoutinesSelector(state),
    unpossibleRoutines: unpossibleRoutinesSelector(state),
    unpossibleParams: unpossibleRoutinesParams(state)
})

const mapDispatchToLoadRoutines = dispatch => ({
    loadRoutines: data => dispatch(loadPossibleRoutines(data)),
    loadUnpossible: data => dispatch(loadUnpossibleRoutines(data))
})

const ConPossibleRoutines = connect(mapStateToWrt,mapDispatchToLoadRoutines)(PossibleRoutinesContainer);

const RoutineSelectQuestion = ({ flowProps, t }) => {
    return (
        <div className="container">
            <div className="row text-center limit-50-h">
                <div className="col s12">
                    <FlowQuestion text={t("Here are routines that match your profile")} className="mb0" />
                    <div className="flow-question-subtitle">{t("Select a routine")}</div>
                </div>
                <div className="col s12">
                    <ConPossibleRoutines flowProps={flowProps} t={t} />
                </div>
            </div>
        </div>
    )
}

const WorkoutTimesSelect = ({ responseData: { workoutTimes }, flowProps, t }) => {
    const mins = t('mins');
    const collection = workoutTimes.map((secTime,index) => {
        const minTime = Math.round(secTime/60);
        const text = minTime < 30 && index === 0 ? `< 30 ${mins}` : `${minTime === 35 ? 30 : minTime} ${mins}`;
        return { text: text, value: secTime };
    })
    const { values, advance, setFieldTouched, setFieldValue } = flowProps;

    return (
        <React.Fragment>
            <SmallButtonSelect  
                name="workoutTime"
                values={values}
                options={collection}
                setFieldValue={autoAdvanceSetValue({ setFieldValue, values, advance })}
                setFieldTouched={setFieldTouched}
                space
                idBase={'workout-time'}
            />
        </React.Fragment>
    )
}

const WorkoutTimesLC = loadingContainer({
    'SUCCESS': WorkoutTimesSelect
})

const WorkoutTimes = ({ flowProps, loadWorkoutTimes, t }) => {

    return (
        <LoadingContainerParent 
            load={loadWorkoutTimes}
            preloaded={() => false}
            component={WorkoutTimesLC}
            flowProps={flowProps}
            t={t}
        />
    )
}

const WorkoutTimesQuestion = ({ flowProps, loadWorkoutTimes, t }) => {
    return (
        <React.Fragment>
            <FlowQuestion text={t("How much time do you have to workout?")} />
            <div className="text-center">
                <WorkoutTimes flowProps={flowProps} loadWorkoutTimes={loadWorkoutTimes} t={t} />
            </div>
        </React.Fragment>
    )
}
    

const TrainingDaysQuestion = ({ flowProps, t }) => {
    const { setFieldValue, advance, values, isValid, setTouched, setFieldTouched, validateForm, errors: { trainingDays: error }, touched: { trainingDays: touched } } = flowProps;
    const subtitleCnames = classnames("flow-question-subtitle",{"red-text": error && touched});
    return (
        <React.Fragment>
            <FlowQuestion text={t("Which days do you want to workout?")} />
            <div className={subtitleCnames}>{t("Pick at least 2 non-consecutive days")}</div>
            <WeekdayButtonSelect 
                startDay={0} 
                name="trainingDays"
                values={values} 
                setFieldValue={setFieldValue}
                setFieldTouched={setFieldTouched}
                dayNames={moment.weekdaysShort()} 
            />
            <NextButton 
                className="btn-wide mt65"
                label={t('Next')} 
                advance={advance} 
                validateForm={validateForm} 
                values={values} 
                isValid={isValid}
                setTouched={setTouched} 
                id='next-btn'
            />
        </React.Fragment>
    )
}

class ExperienceQuestion extends React.Component {

    render() {
        const {flowProps: { advance, values, validateForm, setTouched, setFieldValue, values: { liftingExperience } }, t, user } = this.props;
        const tKeyAdv = `experience level weights advanced ${user.female() ? 'female' : 'male'}`;
        const tKeyInt = `experience level weights intermediate ${user.female() ? 'female' : 'male'}`;
        const strstds = user.strengthStandards(t);

        const options = {
            [t('Beginner')]: { value: 0, subtitle: `${t('beginner tip')} ${t()}` }, 
            [t('Intermediate')]: { value: 1, subtitle: `${t('intermediate tip')} ${user.gymType === 2 ? t(tKeyInt,strstds.intermediate) : ''}` }, 
            [t('Advanced')]: { value: 2, subtitle: `${t('advanced tip')} ${user.gymType === 2 ? t(tKeyAdv,strstds.advanced) : ''}` }
        };

        return (
            <React.Fragment>
                <FlowQuestion text={t("What is your level of training experience?")} className="mt0 pt0 mb20" />
                <SingleOptionSlider className="shorter" options={options} value={liftingExperience} setValue={(val) => setFieldValue('liftingExperience',val) } />
                <NextButton 
                    className="btn-wide mt95"
                    label={t('Next')} 
                    advance={advance} 
                    validateForm={validateForm} 
                    values={values} 
                    isValid={true}
                    setTouched={setTouched} 
                    id='next-btn'
                />
            </React.Fragment>
        )
    }
}

const FocusQuestion = ({ flowProps, t, user } ) => {
    return (
        <React.Fragment>
            <FlowQuestion text={t("What is your primary focus?")} tooltip={t("routine focus tip")} />
            <div className="no-wrap">
                <AutoAdvanceButton {...flowProps} attr="routineFocus" value="0" render={({ onClick }) => (
                    <SmallImageCardOption id="aesthetics-btn" src={user.female() ? aestheticsF : aestheticsM} alt="" onClick={onClick} title={t("Aesthetics")}  />
                )} />
                <AutoAdvanceButton {...flowProps} attr="routineFocus" value="1" render={({ onClick }) => (
                    <SmallImageCardOption id="strength-btn" src={user.female() ? strengthF : strengthM} alt="" onClick={onClick} title={t("Strength")}  />
                )} />
            </div>
        </React.Fragment>
    )
}

const CardioQuestion = ({ flowProps, t }) => {
    return (
        <React.Fragment>
            <FlowQuestion text={t("Do you want to include cardio in your routine?")} />
            <div className="no-wrap">
                <AutoAdvanceButton {...flowProps} attr="needsCardio" value="1" render={({ onClick }) => (
                    <Button color="primary" rounded onClick={onClick} className="btn-wide" id="yes-cardio-btn"><span>{t("Yes")}</span></Button>
                )} />
                <AutoAdvanceButton {...flowProps} attr="needsCardio" value="0" render={({ onClick }) => (
                    <Button color="primary" rounded onClick={onClick} className="btn-wide ml5" id="no-cardio-btn"><span>{t("No")}</span></Button>
                )} />
            </div>
        </React.Fragment>
    )
}

const BannableProgChecks = ({ bannableProgs, flowProps, t }) => (
    <React.Fragment>
        <p>
            {t("Do you have a place to do?")}
        </p>
        <CheckboxGroup 
            values={flowProps.values} 
            errors={flowProps.errors} 
            touched={flowProps.touched} 
            onChange={flowProps.setFieldValue} 
            onBlur={flowProps.setFieldTouched} 
            name="allowedExerciseProgressionIds" 
        >
            {bannableProgs.map((prog) => (
                <Checkbox className="bannable-prog-check" key={prog.id} inputProps={{ value: prog.id} } label={_.capitalize(prog.pluralName)} filled tooltip={prog.equipmentDescription} />
            ))}
        </CheckboxGroup>
    </React.Fragment>
)

const BannableProgsLC = loadingContainer({
    'SUCCESS': BannableProgChecks
})

const AllowedProgsUnconnected = ({ flowProps, loadBannableProgs, bannableProgs, t }) => {
    return (
        <LoadingContainerParent 
            load={loadBannableProgs}
            preloaded={() => !!bannableProgs }
            component={BannableProgsLC}
            bannableProgs={bannableProgs}
            flowProps={flowProps}
            t={t}
        />
    )
}

const mapStateToBannableProgs = state => ({
    bannableProgs: bannableProgSelector(state)
})

const AllowedProgs = connect(mapStateToBannableProgs)(AllowedProgsUnconnected);

class EquipmentQuestion extends React.Component {

    render() {
        const { flowProps, loadBannableProgs, t} = this.props;
        const { advance, values, setTouched, validateForm, isValid } = flowProps;
        const allProps = _.pick(flowProps,[ 'values', 'touched', 'handleChange','setFieldValue', 'handleBlur']);
    
        return (
            <React.Fragment>
                <FlowQuestion text={t("What kind of workouts would you prefer?")} />
                <div className="radio-btn-container">
                    <RCButtonWithErrors id="weighted-radio" name="gymType" label={t("Weighted - barbell focused")} inProps={{ type: 'radio', value: WorkoutRoutine.GYM }} {...allProps} />
                    <RCButtonWithErrors id="no-equipment-radio" name="gymType" label={t("Bodyweight - no equipment")} inProps={{ type: 'radio', value: WorkoutRoutine.BW }} {...allProps} />
                    <RCButtonWithErrors id="bodyweight-radio" name="gymType" label={t("Bodyweight - minimal equipment")} inProps={{ type: 'radio', value: WorkoutRoutine.GYM_BW }} {...allProps} errors={flowProps.errors} />
                    {values.gymType === 1 && (
                        <div className="sub-fields">
                            <AllowedProgs loadBannableProgs={loadBannableProgs} flowProps={flowProps} t={t} />
                        </div>
                    )}
                </div>
                <div>
                    <NextButton 
                        className="btn-wide mt65"
                        label={t('Next')} 
                        advance={advance} 
                        validateForm={validateForm} 
                        values={values} 
                        isValid={isValid}
                        setTouched={setTouched} 
                        id='next-btn'
                    />
                </div>
            </React.Fragment>
        )
    }
}

const flowTransitionMap = {
    rules: [
        [[workoutPlanSlideOutPaths,rootPath],transitions.slideOut],
        [[...emailPaywallMatches],transitions.slideOver]
    ]
};

class WorkoutSetupFlowPage extends Component {

    constructor(props) {
        super(props);
        props.setupTransitions(flowTransitionMap);
        this.props.loadBannableProgs().catch(() => console.log("Failed to load bannable progressions."));
        this.exitPath = homePath();
        this.state = { submitState: 'DEFAULT' };
    }

    setSubmitState = (status) => {
        this.setState({ submitState: status });
    }

    render() {
        const { initialValues, user, advanceAction, loadBannableProgs, loadWorkoutTimes, submit, t, scrollRef } = this.props;

        return (
        <Page ref={scrollRef} white>
            <FlowForm 
                initialValues={initialValues}
                validate={validateForm.bind(this,t)}
                validateOnMount={true}
                advanceCallback={advanceAction}
                onSubmit={formikHandlerCreator(this,this.setSubmitState,submit,valueFilter)}
                basePath={workoutSetupBase}
                exitPath={this.exitPath}
                progress
                nextPage={getNextPage}
            >
                    <FlowPageContent key='equipment' render={(flowProps) => {
                            return (
                                <FlowQuestionContainer>
                                    <EquipmentQuestion flowProps={flowProps} t={t} loadBannableProgs={loadBannableProgs} />
                                </FlowQuestionContainer>
                            )
                    }} />
                    <FlowPageContent key='cardio' render={(flowProps) => {
                            return (
                                <FlowQuestionContainer>
                                    <CardioQuestion flowProps={flowProps} t={t} />
                                </FlowQuestionContainer>
                            )
                    }} />
                    <FlowPageContent key='focus' render={(flowProps) => {
                            return (
                                <FlowQuestionContainer>
                                    <FocusQuestion flowProps={flowProps} t={t} user={user} />
                                </FlowQuestionContainer>
                            )
                    }} />
                    <FlowPageContent key='experience' render={(flowProps) => {
                            return (
                                <FlowQuestionContainer style={{width: '100%'}}>
                                    <ExperienceQuestion flowProps={flowProps} t={t} user={user} />
                                </FlowQuestionContainer>
                            )
                    }} />
                    <FlowPageContent key='trainingDays' render={(flowProps) => {
                            return (
                                <FlowQuestionContainer style={{width: '100%'}}>
                                    <TrainingDaysQuestion flowProps={flowProps} t={t} user={user} />
                                </FlowQuestionContainer>
                            )
                    }} />
                    <FlowPageContent key='workoutTime' render={(flowProps) => {
                            return (
                                <FlowQuestionContainer style={{width: '100%'}}>
                                    <WorkoutTimesQuestion 
                                        loadWorkoutTimes={() => loadWorkoutTimes(flowProps.values)} 
                                        flowProps={flowProps} 
                                        t={t} 
                                        user={user} 
                                    />
                                </FlowQuestionContainer>
                            )
                    }} />
                    <FlowPageContent key='routineSelect' block render={(flowProps) => {
                            return (
                                <RoutineSelectQuestion flowProps={flowProps} t={t} />
                            )
                    }} />
                    <FlowPageContent key='startDate' render={(flowProps) => {
                            return (
                                <FlowQuestionContainer style={{width: '100%'}}>
                                    <StartDateQuestion flowProps={flowProps} t={t} user={user} submitState={this.state.submitState} />
                                </FlowQuestionContainer>
                            )
                    }} />
            </FlowForm>
        </Page>
        );
    }

    componentWillUnmount() {
        if(this.loadPromise) {
            this.loadPromise.cancel();
        }
    }
}

const mapStateToProps = (state) => ({
    initialValues: workoutFlowSelector(state),
    user: userRecordSelector(state)
})

const mapDispatchToProps = dispatch =>({
    advanceAction: (data) => dispatch(advanceWorkoutSetup(data)),
    loadBannableProgs: () => dispatch(loadBannableProgs()),
    loadWorkoutTimes: (data) => dispatch(loadUserWorkoutTimes(data)),
    submit: data => dispatch(assignNewRoutine(data))
})

export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(WorkoutSetupFlowPage));
